module.exports = __webpack_public_path__ + "img/application-die.f5c5d935.jpg";